// English translations for the followup page (French string -> English).
const m: Record<string, string> = {
  // Page header
  'Relances WhatsApp': 'WhatsApp follow-ups',
  '{n} commande en attente de relance': '{n} order awaiting follow-up',
  '{n} commandes en attente de relance': '{n} orders awaiting follow-up',

  // Relative time (Dernière relance cell)
  "À l'instant": 'Just now',
  'Il y a {n} min': '{n} min ago',
  'Il y a {n} h': '{n} h ago',
  'Hier': 'Yesterday',
  'Il y a {n} jours': '{n} days ago',
  'Il y a {n} sem.': '{n} wk ago',
  'Il y a {n} mois': '{n} months ago',
  'Jamais': 'Never',

  // Filter tabs (inline labels)
  'Toutes les relances': 'All follow-ups',
  'Déjà relancé': 'Already followed up',

  // Sub-state labels (from followUpMessages.ts SUB_STATE_LABELS)
  'Couverture non choisie': 'Cover not chosen',
  'Photos manquantes': 'Missing photos',
  'Album suivant manquant': 'Next album missing',
  'Mode non choisi': 'Mode not chosen',
  'Éditeur jamais ouvert': 'Editor never opened',
  "Bloqué dans l'éditeur": 'Stuck in the editor',
  'En production / Imprimé': 'In production / Printed',
  'Couverture disponible': 'Cover available',

  // Confirm dialog
  "Ce client a déjà été relancé aujourd'hui. Envoyer quand même ?":
    'This customer has already been followed up today. Send anyway?',

  // Bulk action bar
  'commande sélectionnée': 'order selected',
  'commandes sélectionnées': 'orders selected',
  ' · auto · délai {s}s': ' · auto · delay {s}s',
  ' · manuel (une à la fois)': ' · manual (one at a time)',
  'Effacer la sélection': 'Clear selection',
  'Envoyer le suivant': 'Send next',
  'Envoyer les {n} sélectionnés': 'Send the {n} selected',

  // Table
  'Sélectionner toutes les lignes visibles': 'Select all visible rows',
  'Sélectionner {name}': 'Select {name}',
  'Commande': 'Order',
  'Téléphone': 'Phone',
  'Bloqué à': 'Stuck at',
  'Dernière relance': 'Last follow-up',
  'Bundle': 'Bundle',
  'aucun': 'none',
  'Déjà relancé récemment — cliquer pour renvoyer':
    'Already followed up recently — click to resend',
  'Renvoyé': 'Resent',
  'Envoyer': 'Send',

  // Empty / error states
  'Erreur lors du chargement des relances.': 'Error loading follow-ups.',
  'Aucune commande à relancer dans cette catégorie.':
    'No orders to follow up in this category.',

  // Bulk config bar
  "Mode d'envoi": 'Send mode',
  'Auto': 'Auto',
  'Manuel': 'Manual',
  'Délai entre envois': 'Delay between sends',
  "Fermer l'éditeur": 'Close editor',
  'Personnaliser les messages': 'Customise messages',

  // Templates editor
  'Messages personnalisés': 'Custom messages',
  'Espaces réservés :': 'Placeholders:',
  'Réinitialiser tout': 'Reset all',
  'modifié': 'modified',
  'Restaurer le message par défaut': 'Restore the default message',
  // 2026-09-29 — submitted, nothing to ask the client (no money before approval).
  'Album soumis — rien à demander au client': 'Album submitted — nothing to ask the client',
};
export default m;
